import { faAngleDown } from "@jewlr/pro-regular-svg-icons/faAngleDown"
import { faAngleUp } from "@jewlr/pro-regular-svg-icons/faAngleUp"
import PropTypes from "prop-types"
import { useState } from "react"

import Button from "components/ui/button"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

import FAQMarkdown from "./markdown"

const FAQAccordion = ({ elementId, item }) => {
  const [showDetails, setShowDetails] = useState(false)

  return (
    <div className="desktop:px-20 tablet:px-16 border-b border-b-black px-8">
      <h3>
        <Button
          aria-controls={`faq-${elementId}-accordion-content-${item.id}`}
          aria-expanded={showDetails}
          className="desktop:py-30 my-10 w-full items-center justify-between gap-8 py-10 text-left"
          id={`faq-${elementId}-accordion-heading-${item.id}`}
          onClick={() => setShowDetails(!showDetails)}
        >
          <span className="h3">{item.question}</span>
          <FontAwesomeIcon
            className="text-24"
            icon={showDetails ? faAngleUp : faAngleDown}
          />
        </Button>
      </h3>
      <Expand
        aria-labelledby={`faq-${elementId}-acccordion-heading-${item.id}`}
        id={`faq-${elementId}-accordion-content-${item.id}`}
        role="region"
        show={showDetails}
      >
        <div className="pb-40">
          {item.rich_answer ? (
            <FAQMarkdown>{item.rich_answer}</FAQMarkdown>
          ) : (
            <p className="body">{item.answer}</p>
          )}
        </div>
      </Expand>
    </div>
  )
}

FAQAccordion.propTypes = {
  elementId: PropTypes.string,
  item: PropTypes.object,
}

export default FAQAccordion
